const reviews = {
  title: () => 'Shop italist | Read real reviews from our customers',
  description: () => 'Looking for italist reviews? Find the most up-to-date italist reviews from our customers',
};

export default reviews;
